var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStudyIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 33 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#1D253C",
    strokeWidth: 2,
    d: "M16 13c3.3137 0 6-2.6863 6-6 0-3.31371-2.6863-6-6-6s-6 2.68629-6 6c0 3.3137 2.6863 6 6 6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#1D253C",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M29.8005 26.7982c0-7.1311-5.7829-12.9139-12.9139-12.9139-7.1311 0-12.91394 5.7828-12.91394 12.9139H29.8005Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#1D253C",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "m3.83203 16 12.34107 5.4075L29.9993 16v17.2405l-13.8262 5.6934-12.34107-5.426V16Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1D253C",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M16.1719 21.4072v17.5264"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#1D253C",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M5 30c-2.20923 0-4-1.7908-4-4s1.79077-4 4-4v8ZM28 22c2.2092 0 4 1.7908 4 4s-1.7908 4-4 4v-8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudyIcon);
export default __webpack_public_path__ + "static/media/study-icon.602bdc092041be4b8df403baea06e0e6.svg";
export { ForwardRef as ReactComponent };